import { gql } from "@apollo/client";
import { BundleProductFragment } from "../RootComponents/Product/BundleProductFragment.gql";

export const GET_WISHLIST_DATA = gql`
  query GetProductsData {
    customer {
      wishlists {
        id
        items_count
        items_v2 {
          items {
            id
            product {
              id
              attribute_set_id
              name
              unit_text
              flag_text
              enable_site_visit
              enable_appliance_site_visit
              url_key
              stock_status
              ... on ConfigurableProduct {
                configurable_options {
                  id
                  attribute_code
                  attribute_id
                  attribute_id_v2
                  label
                  values {
                    uid
                    default_label
                    label
                    store_label
                    use_default_value
                    value_index
                    swatch_data {
                      ... on ImageSwatchData {
                        thumbnail
                      }
                      value
                    }
                  }
                }
              }
              type_id
              description {
                html
              }
              short_description {
                html
              }
              meta_title
              meta_description
              sku
              uid
              categories {
                name
                url_key
              }
              image {
                url
                label
              }
              small_image {
                url
                label
              }
              media_gallery {
                url
                label
                ... on ProductVideo {
                  video_content {
                    media_type
                    video_provider
                    video_url
                    video_title
                    video_description
                    video_metadata
                  }
                }
              }
              simplebundle
              __typename
              ... on BundleProduct {
                ...BundleProductFields
              }
              ... on ConfigurableProduct {
                configurable_options {
                  id
                  uid
                  attribute_id
                  label
                  position
                  use_default
                  attribute_code
                  values {
                    value_index
                    uid
                    label
                    swatch_data {
                      value
                    }
                  }
                  product_id
                }
                variants {
                  attributes {
                    uid
                    label
                    code
                  }
                  product {
                    id
                    name
                    unit_text
                    sku
                    attribute_set_id
                    ... on PhysicalProductInterface {
                      weight
                    }
                    small_image {
                      url
                      label
                    }
                    price_range {
                      minimum_price {
                        regular_price {
                          value
                          currency
                        }
                        final_price {
                          value
                          currency
                        }
                        discount {
                          amount_off
                          percent_off
                        }
                      }
                      maximum_price {
                        regular_price {
                          value
                          currency
                        }
                        final_price {
                          value
                          currency
                        }
                        discount {
                          amount_off
                          percent_off
                        }
                      }
                    }
                  }
                  attributes {
                    label
                    code
                    value_index
                  }
                }
              }
              price_range {
                minimum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
                maximum_price {
                  regular_price {
                    value
                    currency
                  }
                  final_price {
                    value
                    currency
                  }
                  discount {
                    amount_off
                    percent_off
                  }
                }
              }
            }
            ... on ConfigurableWishlistItem {
              configurable_options {
                id
                option_label
                value_id
                value_label
              }
            }
          }
        }
      }
    }
  }
  ${BundleProductFragment}
`;

export const REMOVE_PRODUCTS_FROM_WISHLIST = gql`
  mutation RemoveProductsFromWishlist(
    $wishlistId: ID!
    $wishlistItemsId: [ID!]!
  ) {
    removeProductsFromWishlist(
      wishlistId: $wishlistId
      wishlistItemsIds: $wishlistItemsId
    ) {
      wishlist {
        id
        items_count
        sharing_code
      }
    }
  }
`;

export const ADD_TO_WISHLIST = gql`
  mutation AddProductToWishlistFromGallery(
    $wishlistId: ID!
    $itemOptions: WishlistItemInput!
  ) {
    addProductsToWishlist(
      wishlistId: $wishlistId
      wishlistItems: [$itemOptions]
    ) {
      user_errors {
        code
        message
      }
    }
  }
`;

export default {
  getWishlistData: GET_WISHLIST_DATA,
  removeFromWishlist: REMOVE_PRODUCTS_FROM_WISHLIST,
  addToWishlist: ADD_TO_WISHLIST,
};
